import Phaser from 'phaser';
import BootScene from './scenes/Boot';
import PreloadScene from './scenes/Preload';
import MenuScene from './scenes/Menu';
import LevelSelectScene from './scenes/LevelSelect';
import GameScene from './scenes/Game';
import GameOverScene from './scenes/GameOver';

// ─────────────────────────────────────────────────────────────
// 设计分辨率（游戏逻辑坐标的基准）
// 所有游戏内坐标 / 尺寸 / 字体都基于这套数值，与窗口大小无关。
// 相机视口 = 设计分辨率（固定 960x540）。
// ─────────────────────────────────────────────────────────────
export const GAME_WIDTH = 960;
export const GAME_HEIGHT = 540;

const config: Phaser.Types.Core.GameConfig = {
  type: Phaser.AUTO,
  parent: 'game-container',
  width: GAME_WIDTH,
  height: GAME_HEIGHT,
  backgroundColor: '#1a1a2e',
  pixelArt: true,
  roundPixels: true,
  scale: {
    // FIT：把固定的设计分辨率等比缩放到窗口，居中显示。
    // 视口（游戏单位）恒为 960x540；只有屏幕上的缩放比例随窗口变化。
    // 窗口比例与 16:9 不同时，两侧/上下留黑边——像素游戏的标准做法。
    mode: Phaser.Scale.FIT,
    autoCenter: Phaser.Scale.CENTER_BOTH,
  },
  physics: {
    default: 'arcade',
    arcade: {
      gravity: { x: 0, y: 0 },
      debug: false,
    },
  },
  scene: [BootScene, PreloadScene, MenuScene, LevelSelectScene, GameScene, GameOverScene],
};

const game = new Phaser.Game(config);
// 暴露实例便于调试（生产也可保留，无副作用）
(window as any).game = game;

export default game;
